/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import LoadingOverlay from "../../../components/Ui/LoadingOverlay";
import Pagination from "../../../components/Ui/Paging";
import SearchInput from "../../../components/Ui/Search";
import { calculatePage } from "../../../utils/paging";

import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { IconEdit, IconPlus, IconTrash } from "../../../components/Ui/Icon";
import { COUPON_STATUS } from "../../../constants/index";
import { adminDeleteCoupon, adminGetCoupon } from "../../../services/coupon";
import { formatDateToCustomString } from "../../../utils/utils";
import Create from "./Create";

const List = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(new Date());

  const [isOpenCreate, setIsOpenCreate] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [selectedItem, setSelectedItem] = useState(null);

  const [paging, setPaging] = useState({
    page: parseInt(searchParams.get("page")) || 1,
    limit: parseInt(searchParams.get("limit")) || 10,
    sortBy: searchParams.get("sortBy") || "createdAt",
    sortType: searchParams.get("sortType") || "DESC",
    search: searchParams.get("search") || "",
    total: 0,
    totalPages: 0,
  });

  const setQueryParams = (queryParams) => {
    const searchParams = new URLSearchParams();

    Object.keys(queryParams).forEach((key) => {
      searchParams.set(key, queryParams[key]);
    });

    navigate({ search: searchParams.toString() });
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const dataSubs = await adminGetCoupon(paging);
      setTimeout(() => {
        setData(dataSubs?.data?.data);
        setPaging((prev) => ({
          ...prev,
          total: dataSubs?.data?.total,
          totalPages: calculatePage(dataSubs?.data?.total, prev.limit),
        }));
      });

      setLoading(false);
    };
    fetchData();
    setTimeout(() => {
      setQueryParams(paging);
    });
  }, [
    paging.page,
    paging.limit,
    paging.sortBy,
    paging.sortType,
    paging.search,
    refresh,
  ]);

  const handlePageChange = (page) => {
    setPaging((prev) => ({
      ...prev,
      page,
    }));
  };

  const onSearch = (search) => {
    setPaging((prev) => ({
      ...prev,
      search,
    }));
  };

  // Handler to save the new order
  const handleDelete = async (id) => {
    if (!id) {
      toast.error("Please select a slide to delete");
      return;
    }
    // eslint-disable-next-line no-alert
    const yes = window.confirm("Are you sure you want to delete this item?");
    if (!yes) return;
    setLoading(true);
    try {
      await adminDeleteCoupon(id);

      setRefresh(new Date());
      toast.success("Order updated!");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Update failed");
    }
    setLoading(false);
  };

  const displayStatus = (item, status) => {
    switch (status) {
      case COUPON_STATUS.active:
        if (new Date() > new Date(item.expiredDate)) {
          return (
            <span className="text-red-500 first-letter:uppercase">Expired</span>
          );
        }
        return (
          <span className="text-green-500 first-letter:uppercase">
            {item.status}
          </span>
        );

      default:
        return (
          <span className="text-red-500 first-letter:uppercase">
            {item.status}
          </span>
        );
    }
  };

  const dataSection = useMemo(() => {
    return (
      <table className="w-full text-sm text-left rtl:text-right text-gray-500">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3">
              STT
            </th>
            <th scope="col" className="px-6 py-3">
              Code
            </th>
            <th scope="col" className="px-6 py-3">
              Sermons
            </th>
            <th scope="col" className="px-6 py-3">
              Used Count / Max
            </th>
            <th scope="col" className="px-6 py-3">
              Start Date
            </th>
            <th scope="col" className="px-6 py-3">
              Expired At
            </th>
            <th scope="col" className="px-6 py-3">
              Status
            </th>
            <th scope="col" className="px-6 py-3"></th>

            {/* <th scope="col" className="px-6 py-3">
              <span className="sr-only">Edit</span>
            </th> */}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <>
              <tr key={index} className="bg-white border-b ">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                >
                  {index + 1}
                </th>
                <td className="px-6 py-4">{item.code}</td>
                <td className="px-6 py-4">{item.sermons}</td>
                <td className="px-6 py-4">
                  {item.usedCount + "/" + (item.maxUse || 1)}
                </td>
                <td className="px-6 py-4">
                  {formatDateToCustomString(item.startDate)}
                </td>
                <td className="px-6 py-4">
                  {formatDateToCustomString(item.expiredDate)}
                </td>

                <td className="px-6 py-4">
                  <label className="group inline-flex items-center cursor-pointer">
                    {displayStatus(item, item.status)}
                  </label>
                </td>
                <td>
                  <button
                    onClick={() => {
                      setSelectedItem(item);
                      setIsOpenCreate(true);
                    }}
                    title="Edit"
                    className="text-white mr-2 bg-slate-400 hover:bg-slate-500 rounded focus:ring-4 focus:ring-blue-300 font-medium text-sm px-2.5 py-1 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    <IconEdit className="size-4" />
                  </button>

                  <button
                    onClick={() => handleDelete(item._id)}
                    title="Delete"
                    className="text-white bg-slate-400 hover:bg-slate-500 rounded focus:ring-4 focus:ring-blue-300 font-medium text-sm px-2.5 py-1 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    <IconTrash className="size-4" />
                  </button>
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    );
  }, [data]);

  const pagine = useMemo(() => {
    if (!paging.totalPages || paging.total <= paging.limit) return <></>;
    return (
      <Pagination
        totalPages={paging.totalPages}
        currentPage={paging.page}
        onPageChange={handlePageChange}
      />
    );
  }, [paging.page, paging.totalPages]);
  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      <div className="flex w-full justify-between items-center p-3 flex-wrap md:flex-nowrap">
        <h2 className="font-semibold text-3xl text-left rtl:text-right text-gray-900">
          Coupon
        </h2>
        <div className="inline-flex items-center gap-2">
          <a
            href="#create"
            onClick={(e) => setIsOpenCreate(true)}
            type="button"
            className="flex items-center p-2 text-sm font-medium h-full text-white bg-blue-700 rounded-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300"
          >
            <IconPlus />
            <span> Create</span>
          </a>
          <SearchInput className="md:mr-28" onSubmitSearch={onSearch} />
        </div>
      </div>
      {dataSection}
      {pagine}
      {loading && <LoadingOverlay />}

      {isOpenCreate && (
        <Create
          onSubmited={(e) => setRefresh(new Date())}
          togglePopup={() => {
            setSelectedItem(null);
            setIsOpenCreate(false);
          }}
          data={selectedItem}
        />
      )}
    </div>
  );
};

export default List;
